import { SHOW_MODAL, HIDE_MODAL } from "../actions/types";
const initial_state = {
  activeModal: undefined,
  modalData: undefined,
};

// step 3 define reducers use module.exports for reducers,
function ModalsReducer(state = initial_state, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        activeModal: action.modal,
        modalData: action.modalContent,
      };
    case HIDE_MODAL:
      return {
        ...state,
        activeModal: undefined,
        modalData: undefined,
      };
    default:
      return state;
  }
}

export default ModalsReducer;



// WEBPACK FOOTER //
// ./src/reducers/modalsReducer.js